import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';

import { getApplicantEmail } from '../../../api/lendingAPI/CustomerStateAPIHelper';
import { InformationSVG } from '../../../svgComponents/informationSVG/index';
import { GreenTickStatusSVG } from '../../../svgComponents/greenTickStatusSVG/index';
import { usePostApi } from './postApi.hook';
import messages from './AccountDetails.messages';
import { ErrorText, H2, Input, Label, SuccessText, Text } from '@ui';
import profileMessages from '../Profile.messages';
import { Button } from '@iwoca/orion';
import { ErrorIcon } from '@icons';

const mapStateToProps = (state) => ({
    accountEmail: getApplicantEmail(state)
});

const AccountDetails = ({ accountEmail }) => {
    const intl = useIntl();
    const { status, hasError, isLoading, triggerFetch } = usePostApi({
        endpoint: '/api/lending/edge/password/reset/'
    });

    return (
        <div className="space-y-xl">
            <H2>
                <FormattedMessage {...profileMessages.accountDetailsTitle} />
            </H2>

            <div className="space-y-l rounded-md border border-secondary-90 bg-structure-100 p-l">
                <div className="flex flex-col items-start space-y-s">
                    <Label htmlFor="account-email">
                        <FormattedMessage {...messages.accountEmail} />
                    </Label>
                    <Input
                        className="w-full max-w-xl"
                        id="account-email"
                        name="account-email"
                        disabled
                        value={accountEmail}
                    />
                </div>

                <div className="space-y-s">
                    <Text>
                        <FormattedMessage {...messages.setNewPassword} />
                    </Text>
                    <Button
                        onClick={() =>
                            triggerFetch({ data: { email: accountEmail } })
                        }
                        loading={isLoading}
                    >
                        <FormattedMessage {...messages.resetPasswordCTA} />
                    </Button>

                    {!hasError && status === 204 ? (
                        <div className="flex items-center">
                            <GreenTickStatusSVG className="mr-xs shrink-0" />
                            <SuccessText>
                                <FormattedMessage
                                    {...messages.successSentResetPassword}
                                />
                            </SuccessText>
                        </div>
                    ) : null}

                    {hasError && status !== 204 ? (
                        <div className="flex items-center">
                            <ErrorIcon className="mr-xs shrink-0" />
                            <ErrorText>
                                <FormattedMessage
                                    {...messages.failureResetPassword}
                                />
                            </ErrorText>
                        </div>
                    ) : null}
                </div>

                <div className="flex items-center">
                    <InformationSVG className="mr-xs shrink-0" />
                    <Text
                        className="text-s font-medium"
                        dangerouslySetInnerHTML={{
                            __html: intl.formatMessage(messages.changeEmailInfo)
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(AccountDetails);
